import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "deferally_token";
export const ADMIN_FIRM_KEY = "deferally_admin_firm";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const fid = localStorage.getItem(ADMIN_FIRM_KEY);
  if (fid && (cfg.url || "").includes("/enterprise/")) {
    cfg.params = { ...(cfg.params || {}), firm_id: fid };
  }
  return cfg;
});

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && x.msg ? x.msg : JSON.stringify(x))).join(" ");
  if (detail.msg) return detail.msg;
  return String(detail);
}
